export default "__VITE_ASSET__DukJm4Gr__"